import { Component, Input } from '@angular/core';
import { IconConfig } from '../../notes/icon/icon.model';

@Component({
  selector: 'text-with-icon',
  template: `<div
    class="TextWithIcon"
    [ngClass]="{
      'TextWithIcon--Left': !iconRight,
      'TextWithIcon--Right': iconRight,
    }"
  >
    <div class="TextWithIcon__Icon">
      <icon [name]="iconName" [config]="config"></icon>
    </div>
    <div class="TextWithIcon__Text">
      <ng-content></ng-content>
    </div>
  </div>`,
  styleUrls: ['./text-with-icon.component.scss'],
})
export class TextWithIconComponent {
  @Input() config: IconConfig;
  @Input() iconName: string;
  @Input() iconRight: boolean;
}
